import React, { FC } from 'react'
import { Component } from '../../types/ContentStructure'
import { Box, Typography } from '@mui/material'
interface IComponentTextProps {
    component: Component
    sx?: any
}
const ComponentText: FC<IComponentTextProps> = ({ component, sx }) => {
    const { title, subTitle, text, theme } = component;
    return (
        <Box sx={sx}>
            {title &&
                <Typography variant="h4" sx={[theme.themeStyles, { fontWeight: 'bold', backgroundColor: 'transparent' }, sx]}>
                    {title}
                </Typography>
            }
            {subTitle &&
                <Typography variant="h6" sx={[theme.themeStyles, { backgroundColor: 'transparent' }, sx]}>
                    {subTitle}
                </Typography>
            }
            {text &&
                <Typography sx={[theme.themeStyles, { textWrap: 'pretty', textAlign: 'left', backgroundColor: 'transparent' }, sx]}>
                    {text}
                </Typography>
            }
        </Box>
    )
}

export default ComponentText
